import React from 'react';

const PenIcon = (props) => (
  <svg
    {...props}
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
  >
    <path fillRule="evenodd" clipRule="evenodd" d="M17.9885 7.13897C17.9885 7.73551 17.7518 8.30769 17.3305 8.72997L10.2175 15.839L6.65278 16.419C6.31576 16.4738 6.02414 16.1822 6.07897 15.8452L6.65897 12.2805L13.77 5.16897C14.1923 4.74762 14.7644 4.51099 15.361 4.51099C15.9575 4.51099 16.5297 4.74762 16.952 5.16897L17.3305 5.54797C17.7518 5.97025 17.9885 6.54243 17.9885 7.13897ZM16.27 6.60847L15.8915 6.22997C15.8218 6.1602 15.7386 6.10485 15.6475 6.06709C15.5564 6.02932 15.4588 6.00988 15.3602 6.00988C15.2616 6.00988 15.164 6.02932 15.0729 6.06709C14.9819 6.10485 14.8991 6.1602 14.8295 6.22997L14.033 7.02647L15.483 8.45647L16.27 7.66947C16.3397 7.59982 16.395 7.51712 16.4327 7.4261C16.4704 7.33507 16.4898 7.2375 16.4898 7.13897C16.4898 7.04044 16.4704 6.94287 16.4327 6.85185C16.395 6.76082 16.3397 6.67812 16.27 6.60847ZM8.06197 13L7.78247 14.7175L9.49997 14.438L14.423 9.51897L12.973 8.08897L8.06197 13Z" fill="currentColor" />
    <path d="M5 18.75C5 18.3358 5.33579 18 5.75 18H18.25C18.6642 18 19 18.3358 19 18.75C19 19.1642 18.6642 19.5 18.25 19.5H5.75C5.33579 19.5 5 19.1642 5 18.75Z" fill="currentColor" />
  </svg>
);

export default React.memo(PenIcon);
